import React from "react";
import { TableContentForRouteWiseCollectionTypeTotal } from '../../../Common/Table/tableContent';
import tokenService from "../../../../Common/tokenDecoder";

export default class ComponentToPrint extends React.Component {
    render() {
        const searchData = this.props.searchData;
        const reportData = this.props.data;
        const contentRowNames = this.props.rowNames;
        const columnNames = this.props.columnNames;
        const totalFooter = this.props.totalFooter;
        const footerFullTotal = this.props.footerFullTotal;

        return (
            <div>
                <h3><center><u>Route Wise Collection Type Total Report</u></center></h3>
                <div className="row pb-4 pt-4 pl-2">
                    <div className="col"><b>Group: </b> {searchData.group}</div>
                    <div className="col"><b>Factory: </b> {searchData.factory}</div>
                    <div className="col"><b>Route: </b> {searchData.route === undefined ? "All Routes" : searchData.route}</div>
                    <div className="col"><b>From Date: </b> {searchData.fromDate}</div>
                    <div className="col"><b>To Date: </b> {searchData.toDate}</div>
                </div>
                <div className="row pb-4 pt-4 pl-2">
                    <div className="col"><b>Date: </b> {new Date().toLocaleString()}</div>
                    <div className="col"><b>User: </b> {tokenService.getUserNameFromToken()}</div>
                </div>
                <div>
                    <div className="row">
                        <div className="col-md-12">
                            <table id="routeWiseCropDetailsPdf" className="display dataTable no-footer" style={{ width: "100%" }}>
                                <thead>
                                    <tr>
                                        {columnNames.map((x, index) => {
                                            return (
                                                <th key={index}>{x}</th>
                                            );
                                        })}
                                    </tr>
                                </thead>
                                <tbody>
                                    <TableContentForRouteWiseCollectionTypeTotal
                                        data={reportData}
                                        contentRowNames={contentRowNames}
                                        hasEdit={false}
                                    />
                                </tbody>
                                <tfoot>
                                    <tr>
                                        <th colSpan={2}>Total</th>
                                        {totalFooter.map((x, index) => {
                                            return (
                                                <th key={index} style={{textAlign: "right"}}>{x}</th>
                                            );
                                        })}
                                        <th style={{textAlign: "right"}}>{footerFullTotal}</th>
                                    </tr>
                                </tfoot>
                            </table>
                        </div>
                    </div>

                </div>
            </div>
        );
    }
}